import FilterFactory from '@/lib/filterFactory';

export default class PartnersFilter {
    filterHandlers = {
        update: 'partnersFilter/updateFilter',
        reset: 'partnersFilter/resetFilter',
        resetState: 'partnersFilter/resetFilterState',
        removeSelected: 'partnersFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createRadioEntity('isActive');
        filter.setTitle('isActive', 'Партнерское предложение активно');
        filter.setName('isActive', 'radio_is_active');
        filter.setPreviewName('isActive', 'Активно');
        filter.setRadioList('isActive', [
            { id: 0, name: 'Активно', checked: false },
            { id: 1, name: '', checked: false },
            { id: 2, name: 'Не активно', checked: false },
        ]);
        filter.setAction('isActive', 'partnersFilter/updateRadio');
        filter.setClassName('isActive', 'col-1-row-3');

        this.filterModel = filter.filterModel;
    }
}
